import "./EmailPreview.scss";
import { Text, ScrollArea, Divider } from "@mantine/core";
import { formatDateToMMDDYYYY } from "@/utilities";

interface EmailPreviewProps {
  selectedEmail: Email | null;
  emails?: Email[];
  onEmailSelect: (email: Email) => void;
}

interface Email {
  subject: string;
  sendDate: string;
  content: string;
  id: number;
}

const EmailPreview = ({
  selectedEmail,
  emails,
  onEmailSelect,
}: EmailPreviewProps) => {
  // Render list of emails using button elements for accessibility
  const renderEmailList = () => {
    if (!emails || emails.length === 0) {
      return <Text>No email history available.</Text>;
    }

    return (
      <div className="side-panel">
        {emails.map((email, index) => {
          const emailId = email.id ?? index;
          return (
            <button
              className={`email-preview-item ${
                selectedEmail && (selectedEmail.id ?? 0) === emailId
                  ? "selected"
                  : ""
              }`}
              key={emailId}
              onClick={() => onEmailSelect({ ...email, id: emailId })}
            >
              <Text p="xs" fw={500}>
                {email.subject}
              </Text>
            </button>
          );
        })}
      </div>
    );
  };

  // Render email details section
  const renderEmailDetails = () => {
    if (!selectedEmail) {
      return <Text>Select an email to view its details.</Text>;
    }

    return (
      <>
        <div className="email-preview-header">
          <div className="email-preview-header-text">
            <Text size="lg" fw={600}>
              Email Details
            </Text>
            <div className="email-preview-header-label">
              <Text c="dimmed" size="sm">
                Subject:
              </Text>
              <Text size="sm" fw={500}>
                {selectedEmail.subject}
              </Text>
            </div>
            <div className="email-preview-header-label">
              <Text c="dimmed" size="sm">
                Date and time:
              </Text>
              <Text size="sm">
                {formatDateToMMDDYYYY(selectedEmail.sendDate)}
              </Text>
            </div>
            <Divider my="sm" />
          </div>
        </div>
        <ScrollArea h={"400px"} type="always">
          <div className="email-preview-body">
            <div
              dangerouslySetInnerHTML={{
                __html: selectedEmail.content,
              }}
            />
          </div>
        </ScrollArea>
      </>
    );
  };

  return (
    <div className="email-preview">
      <div className="email-preview-list">
        <ScrollArea h={"600px"}>{renderEmailList()}</ScrollArea>
      </div>
      <div className="email-preview-content">{renderEmailDetails()}</div>
    </div>
  );
};

export default EmailPreview;
